import { render, staticRenderFns } from "./GrandBadgeDropdown.vue?vue&type=template&id=4add3d74"
import script from "./GrandBadgeDropdown.vue?vue&type=script&lang=js"
export * from "./GrandBadgeDropdown.vue?vue&type=script&lang=js"
import style0 from "./grandBadgeDropdown.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports